import { useEffect, useState } from "react";

let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
}

export function registerSW() {
  if ("serviceWorker" in navigator) {
    const base = process.env.PUBLIC_URL || "";
    window.addEventListener("load", () => navigator.serviceWorker.register(`${base}/sw.js`).catch(() => {}));
  }
}

export async function clearOfflineCache() {
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.filter((k) => k.startsWith("si-crm-api")).map((k) => caches.delete(k)));
  }
}

export const useInstall = () => {
  const [, setN] = useState(0);
  useEffect(() => { const f = () => setN((x) => x + 1); subs.add(f); return () => subs.delete(f); }, []);
  const installed = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const promptInstall = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    deferred = null;
    emit();
  };
  return { canInstall: !!deferred, installed, isIOS: /iphone|ipad|ipod/i.test(navigator.userAgent), promptInstall };
};

export const useOnline = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
};
